import { Container, Row } from "reactstrap"
import { Breadcrumbs } from "../../../AbstractElements"
import { Apps, LetterBoxTitle } from "../../../Constants/Constants"
import EmailSidebar from "./EmailSidebar/EmailSidebar"
import { useState } from "react"
import EmailRightSide from "./EmailRightSide/EmailRightSide"

const LetterBoxContainer = () => {
  const [navId, setNavId] = useState("1");

  return (
    <>
    <Breadcrumbs mainTitle={LetterBoxTitle} parent={Apps} />
    <Container fluid>
      <div className="email-wrap email-main-wrapper">
        <Row>
          <EmailSidebar navId={navId} setNavId={setNavId} />
          <EmailRightSide navId={navId} />
        </Row>
      </div>
    </Container>
    </>
  )
}

export default LetterBoxContainer